import React, { Fragment, useState } from "react";
import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { Button, useTheme, Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PropTypes from "prop-types";
import Loader from "../public/Loader";
import { useHistory } from "react-router-dom";
import { getStyleForThankyouResponse } from "../styles/commonStyles";
import { CustomRadio } from "../../components/FormikValidatedComponents/CustomRadio";

const SCREENING_OPTIONS = [
  { value: "colonoscopy", label: "Colonscopy" },
  { value: "colonography", label: "CT Colonography (Virtual colonoscopy)" },
  { value: "sigmoidoscopy", label: "Flexible Sigmoidoscopy" },
  { value: "cologuard", label: "Cologuard" },
  { value: "fobt", label: "Fecal Occult Blood Test [FOBT]" },
];

const ScreeningQuestionOne = ({
  questionText,
  backRoute,
  nextRoute,
  onSubmitHandler,
}) => {
  const theme = useTheme();
  const classes = getStyleForThankyouResponse(theme);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    const body = {
      [`${values.selectedOption}`]: { date: null, note: null },
    };
    const details = {
      selectedOption: values.selectedOption,
    };
    setLoading(true);
    const result = await onSubmitHandler(body);
    setLoading(false);
    if (result) {
      history.push({ pathname: nextRoute, state: details });
    }
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <Formik
        initialValues={{ selectedOption: "" }}
        validationSchema={object({
          selectedOption: string().required(),
        })}
        validateOnMount={true}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Box component="div" sx={classes.wrapper}>
              <Button sx={classes.back} onClick={() => history.push(backRoute)}>
                <ArrowBackIcon /> &nbsp;Back
              </Button>
              <br />
              <br />
              <Typography sx={classes.subTitle2}>{questionText}</Typography>
              <br />
              <Field
                name="selectedOption"
                label="screening options"
                options={SCREENING_OPTIONS}
                component={CustomRadio}
              />
              <br />
              <br />
              <Button
                type="submit"
                sx={classes.btnStyle}
                disabled={loading || !!formikProps.errors.selectedOption}
              >
                Next
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

ScreeningQuestionOne.propTypes = {
  questionText: PropTypes.string.isRequired,
  backRoute: PropTypes.string.isRequired,
  nextRoute: PropTypes.string.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
};

export default ScreeningQuestionOne;
